/* eslint-env browser, jquery */
import 'bootstrap';
import domify from 'domify';
import page from 'modules/ab-page-js';
import $ from 'jquery';
import ContactForm from 'auth0-contact-form';
import { ContactUsForm } from 'components';
import { render as clientRender, unmountComponentAtNode } from 'react-dom';
import React from 'react';
import lottie from 'lottie-web';
import Animation from 'modules/animation-timeline';
import container from 'modules/section-content';
import './plugins/stalkerMenu';
import splash from './view/landing.pug';
import metadata from './metadata.json';
import animationUnify from './animations/unify/data.json';
import animationPersonalize from './animations/personalize/data.json';
import animationSubscriptions from './animations/subscriptions/data.json';

const metricsLib = window.metricsLib;
let onScrolAnimation = null;

export default function register() {
  page('/media-publishing', render, snippets);
  page.exit('/media-publishing', unmountContactForm);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);
  /* eslint-env browser */
  clientRender(
    <ContactUsForm
      source="Media & Publishing"
      subject="New lead from Media & Publishing landing page"
      formId="media-publishing-contact-form"
    />,
    document.querySelector('.contact-us-app')
  );
  return next();
}

function snippets(ctx, next) {
  setupContactForm();
  $('.stalker-menu-container').stalkerMenu();
  const firstPartyAnimation = setupFirstPartyAnimation();
  setupAnimations(firstPartyAnimation);
  const heroAnimation = setupHeroAnimation();
  heroAnimation.run();

  next();
}

function unmountContactForm(ctx, next) {
  unmountComponentAtNode(document.querySelector('.contact-us-app'));
  if (onScrolAnimation) {
    window.removeEventListener('scroll', onScrolAnimation);
  }
  next();
}

function setupContactForm() {
  const salesContactFormOptions = {
    onModalOpen() {
      metricsLib.track('click:contact-sales');
    },
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:media-publishing-contact-form', metricsData);
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:media-publishing-contact-form', metricsData);
    },
    source: 'media-publishing-page'
  };
  const salesContactForm = new ContactForm(salesContactFormOptions);

  const salesFormButton = document.querySelector('.open-contact-form-modal');
  salesFormButton.addEventListener('click', () =>
    salesContactForm.show({ includePhoneField: true })
  );
}

// -------- Events Animations

function setupFirstPartyAnimation() {
  const $elem = $('.media-publishing-page .first-party-animation');
  const animation = new Animation($elem);

  return animation
    .addClass('initial')
    .removeClass('callout-1')
    .fadeIn(300)
    .delay(3000)
    .toggleClass('callout-1');
}

//  -------- End Play Animations

function setupAnimations(firstPartyAnimation) {
  const containerUnify = document.getElementById('animation-unify');
  const containerPersonalize = document.getElementById('animation-personalize');
  const containerSubscriptions = document.getElementById('animation-subscriptions');

  const unifyLottie = {
    container: containerUnify,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    animationData: animationUnify
  };

  const personalizeLottie = {
    container: containerPersonalize,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    animationData: animationPersonalize
  };

  const subscriptionsLottie = {
    container: containerSubscriptions,
    renderer: 'svg',
    loop: false,
    autoplay: false,
    animationData: animationSubscriptions
  };

  const section1Animation = lottie.loadAnimation(unifyLottie);
  const section2Animation = lottie.loadAnimation(personalizeLottie);
  const section3Animation = lottie.loadAnimation(subscriptionsLottie);

  playAnimations(firstPartyAnimation, section1Animation, section2Animation, section3Animation);
}

function playAnimations(
  firstPartyAnimation,
  section1Animation,
  section2Animation,
  section3Animation
) {
  onScrolAnimation = onScrollAnimationFactory(
    firstPartyAnimation,
    section1Animation,
    section2Animation,
    section3Animation
  );
  window.addEventListener('scroll', onScrolAnimation);
}

function onScrollAnimationFactory(
  firstPartyAnimation,
  section1Animation,
  section2Animation,
  section3Animation
) {
  return () => {
    if ($('.section-0').hasClass('initialized') && !$('.section-0').hasClass('animated')) {
      firstPartyAnimation.run();
      $('.section-0').addClass('animated');
    }
    if ($('.section-1').hasClass('initialized')) {
      section1Animation.play();
    }
    if ($('.section-2').hasClass('initialized')) {
      section2Animation.play();
    }
    if ($('.section-3').hasClass('initialized')) {
      section3Animation.play();
    }
  };
}

function setupHeroAnimation() {
  const $elem = $('.media-publishing-page .hero-animation');
  const animation = new Animation($elem);

  return animation
    .delay(300)
    .addClass('initial')
    .removeClass('callout-1')
    .fadeIn(300)
    .delay(300)
    .toggleClass('callout-1');
}



// WEBPACK FOOTER //
// ./src/pages/media-publishing/client.js